import { ViewModes } from '@allesauto/utils/consts';
import { isAuregoShop } from '@allesauto/utils/funcs.ts';
import { List20, Switcher20 } from '@carbon/icons-react';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';
import { WL_INTEGRATION_SLUG_AUREGO } from 'web/src/features/whitelabel/util/getWhiteLabelIntegrationSlugs';

import Button from '../button';
import { useWhiteLabel } from '../whiteLabel';

export interface SwitchListTileProps {
  label?: string;
  viewMode?: ViewModes;
  onChange?: (value: ViewModes) => void;
  disabled?: boolean;
}

const SwitchListTile: FC<SwitchListTileProps> = ({
  label,
  viewMode = ViewModes.DEFAULT,
  onChange,
  disabled = false,
}: SwitchListTileProps) => {
  const [currentViewMode, setCurrentViewMode] = useState<ViewModes>(viewMode);
  const whiteLabel = useWhiteLabel();

  useEffect(() => {
    setCurrentViewMode(viewMode);
  }, [viewMode]);

  const className = {
    defaultBtnClassName:
      '!border-0 !rounded-circle focus:ring-opacity-0 h-[50px] w-[50px] !p-[15px] !shadow-none',
    selectedBtnClassName: disabled
      ? '!bg-grey30 !text-white'
      : `${
          isAuregoShop(whiteLabel)
            ? '!bg-grey90 !text-purple80 monochrome:!text-white monochrome:!bg-grey90'
            : '!bg-purple80 !text-white monochrome:!bg-brandColor'
        }`,
    unselectedBtnClassName: !disabled
      ? '!bg-grey10 !text-purple80 monochrome:!text-grey90 monochrome:!bg-white'
      : '!bg-grey10 !text-grey50',
    labelClassName: 'mr-10px font-regular font-normal text-p1 text-grey80',
  };

  return (
    <div className="flex items-center">
      {!!label && <div className={className.labelClassName}>{label}</div>}
      <Button
        disabled={disabled}
        icon={<Switcher20 />}
        customClassName={clsx(
          className.defaultBtnClassName,
          currentViewMode === ViewModes.GRID
            ? className.selectedBtnClassName
            : className.unselectedBtnClassName,
          whiteLabel?.merchantOrigin === WL_INTEGRATION_SLUG_AUREGO &&
            'monochrome:!bg-[#48a0db]'
        )}
        onClick={() => {
          setCurrentViewMode(ViewModes.GRID);
          onChange && onChange(ViewModes.GRID);
        }}
      />

      <Button
        disabled={disabled}
        icon={<List20 />}
        customClassName={clsx(
          className.defaultBtnClassName,
          currentViewMode === ViewModes.LIST
            ? className.selectedBtnClassName
            : className.unselectedBtnClassName
        )}
        onClick={() => {
          setCurrentViewMode(ViewModes.LIST);
          onChange && onChange(ViewModes.LIST);
        }}
      />
    </div>
  );
};

export default SwitchListTile;
